// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Menu_wrapper__x6VoM","item":"Menu_item__2s-a7","active":"Menu_active__6oYyu"};